/***
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 **/

import { EventExchangeBase } from "./event-exchange.base";
import { EventExchangeLongLived } from "./event-exchange.long-lived";
import { EventExchangeOneTime } from "./event-exchange.one-time";
import { EventExchangeLongLivedMessageExtension } from "./event-exchange.long-lived.message-extension";
import { EventExchangeLongLivedMessageClient } from "./event-exchange.long-lived.message-client";
import { Logger } from "../logger";

export enum EventExchangeType {
   OneTime,
   LongLived
}
export function getEventExchange(
   allowedPeerAddresss: Array<string>|null,
   type: EventExchangeType,
   isForIWA: boolean = false,
   getTrustOriginList?: (string) => Promise<Array<string>>,
   isTrustSyncMessage?: (SDKRawEvent) => boolean
): EventExchangeBase {
   if(isForIWA){
      if(type === EventExchangeType.OneTime) {
         throw "OneTime message exchange not implemented for IWA SDK";
      }
      if(location.protocol === "chrome-extension:"){
         Logger.info("create EventExchangeLongLivedMessageExtension");
         return new EventExchangeLongLivedMessageExtension(
            allowedPeerAddresss,
            getTrustOriginList,
            isTrustSyncMessage
         );
      } else if(location.protocol === "isolated-app:"){// or https:// for web in the future
         Logger.info("create EventExchangeLongLivedMessageClient");
         return new EventExchangeLongLivedMessageClient(
            allowedPeerAddresss,
            getTrustOriginList,
            isTrustSyncMessage
         );
      }
      throw "Service loaded in the unsupported content, must run on either IWA or Chrome Extension";
   }
   if (type === EventExchangeType.OneTime) {
      Logger.info("create EventExchangeOneTime");
      return new EventExchangeOneTime(
         allowedPeerAddresss,
         getTrustOriginList,
         isTrustSyncMessage
      );
   } else if (type === EventExchangeType.LongLived) {
      Logger.info("create EventExchangeLongLived");
      return new EventExchangeLongLived(
         allowedPeerAddresss,
         getTrustOriginList,
         isTrustSyncMessage
      );
   }

}

export {
   EventExchangeBase as EventExchange,
   SDKReceivedRawRequest,
   DisconnectEvent
} from "./event-exchange.base";
